// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","searchBar":"Header_searchBar__+4XIe"};